import React, { useState } from 'react';
import { supabase } from '../supabase';

const L = {
  void:     '#08090a',
  carbon:   '#0f1011',
  obsidian: '#161718',
  graphite: '#23252a',
  fog:      '#8a8f98',
  mist:     '#d0d6e0',
  paper:    '#ffffff',
  blue:     '#2563eb',
  blueDim:  '#1d4ed8',
};

const inter = `-apple-system, BlinkMacSystemFont, "Inter", "Segoe UI", Roboto, sans-serif`;

const inputStyle = {
  width: '100%', boxSizing: 'border-box',
  background: 'rgba(255,255,255,0.03)',
  border: `1px solid ${L.graphite}`,
  borderRadius: 6, padding: '10px 12px',
  fontSize: 14, color: L.mist,
  fontFamily: inter, outline: 'none',
  letterSpacing: '-0.011em',
  transition: 'border-color 0.15s',
};

const labelStyle = {
  display: 'block', fontSize: 12, fontWeight: 510,
  color: L.fog, marginBottom: 6,
  letterSpacing: '-0.011em', fontFamily: inter,
};

export default function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [vista, setVista] = useState('login');
  const [emailRecovery, setEmailRecovery] = useState('');
  const [enviando, setEnviando] = useState(false);

  async function handleLogin(e) {
    e.preventDefault();
    setError('');
    setLoading(true);
    const { error } = await supabase.auth.signInWithPassword({ email, password });
    if (error) setError('Email o contraseña incorrectos.');
    setLoading(false);
  }

  async function handleRecovery(e) {
    e.preventDefault();
    setError('');
    setEnviando(true);
    const em = emailRecovery.trim().toLowerCase();
    const { data: existe, error: rpcError } = await supabase.rpc('email_registrado', { p_email: em });
    if (rpcError) { setError('No se pudo verificar el email. Intentá de nuevo.'); setEnviando(false); return; }
    if (!existe) { setError('Este email no está registrado.'); setEnviando(false); return; }
    await supabase.auth.resetPasswordForEmail(em, { redirectTo: 'https://miestudiojuridico.com/app' });
    setEnviando(false);
    setVista('recovery_ok');
  }

  const wrap = {
    minHeight: '100vh', background: L.void,
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    padding: 24, fontFamily: inter,
  };

  const card = {
    width: '100%', maxWidth: 380,
    background: L.carbon,
    border: `0.5px solid ${L.graphite}`,
    borderRadius: 12,
    padding: '36px 32px',
    boxShadow: `rgba(0,0,0,0.6) 0px 4px 32px`,
  };

  const Logo = () => (
    <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 32 }}>
      <img src="/logo.svg" alt="Mi Estudio" width="32" height="32" style={{ objectFit: 'contain', flexShrink: 0 }} />
      <div>
        <div style={{ fontSize: 15, fontWeight: 510, color: L.paper, letterSpacing: '-0.011em' }}>Mi Estudio</div>
        <div style={{ fontSize: 11, color: L.fog, letterSpacing: '-0.011em' }}>Gestión jurídica integral</div>
      </div>
    </div>
  );

  const ErrorBox = ({ msg }) => msg ? (
    <div style={{ background: 'rgba(239,68,68,0.08)', border: '0.5px solid rgba(239,68,68,0.25)', color: '#f87171', borderRadius: 6, padding: '10px 12px', fontSize: 13, marginBottom: 16, letterSpacing: '-0.011em' }}>
      {msg}
    </div>
  ) : null;

  if (vista === 'recovery_ok') return (
    <div style={wrap}>
      <div style={card}>
        <Logo />
        <div style={{ textAlign: 'center' }}>
          <div style={{ fontSize: 28, marginBottom: 12 }}>📧</div>
          <div style={{ fontSize: 16, fontWeight: 510, color: L.paper, marginBottom: 8, letterSpacing: '-0.011em' }}>Revisá tu email</div>
          <div style={{ fontSize: 13, color: L.fog, marginBottom: 24, lineHeight: 1.65, letterSpacing: '-0.011em' }}>
            Te enviamos un enlace para restablecer tu contraseña a <span style={{ color: L.mist, fontWeight: 510 }}>{emailRecovery}</span>.<br/><br/>
            Si no lo ves en tu bandeja de entrada, revisá la carpeta de spam.
          </div>
          <button style={{ width: '100%', background: 'transparent', border: `1px solid ${L.graphite}`, color: L.mist, borderRadius: 6, padding: '10px', fontSize: 13, fontWeight: 510, cursor: 'pointer', letterSpacing: '-0.011em', fontFamily: inter }}
            onClick={() => { setVista('login'); setEmailRecovery(''); }}>
            Volver al inicio de sesión
          </button>
        </div>
      </div>
    </div>
  );

  if (vista === 'recovery') return (
    <div style={wrap}>
      <div style={card}>
        <Logo />
        <div style={{ fontSize: 17, fontWeight: 510, color: L.paper, marginBottom: 6, letterSpacing: '-0.011em' }}>Recuperar contraseña</div>
        <div style={{ fontSize: 13, color: L.fog, marginBottom: 24, letterSpacing: '-0.011em' }}>Ingresá tu email y te enviamos un enlace para restablecer tu contraseña.</div>
        <form onSubmit={handleRecovery}>
          <div style={{ marginBottom: 20 }}>
            <label style={labelStyle}>Email</label>
            <input type="email" value={emailRecovery} onChange={e => setEmailRecovery(e.target.value)}
              placeholder="tu@email.com" required autoFocus style={inputStyle}
              onFocus={e => e.target.style.borderColor = L.blue}
              onBlur={e => e.target.style.borderColor = L.graphite}
            />
          </div>
          <ErrorBox msg={error} />
          <button type="submit" disabled={enviando} style={{ width: '100%', background: L.blue, color: L.paper, border: 'none', borderRadius: 6, padding: '11px', fontSize: 14, fontWeight: 510, cursor: enviando ? 'not-allowed' : 'pointer', opacity: enviando ? 0.7 : 1, letterSpacing: '-0.011em', fontFamily: inter, marginBottom: 10 }}>
            {enviando ? 'Enviando...' : 'Enviar enlace'}
          </button>
          <button type="button" style={{ width: '100%', background: 'transparent', border: `1px solid ${L.graphite}`, color: L.fog, borderRadius: 6, padding: '10px', fontSize: 13, fontWeight: 400, cursor: 'pointer', letterSpacing: '-0.011em', fontFamily: inter }}
            onClick={() => { setVista('login'); setError(''); }}>
            Volver
          </button>
        </form>
      </div>
    </div>
  );

  return (
    <div style={wrap}>
      <div style={card}>
        <Logo />
        <div style={{ fontSize: 17, fontWeight: 510, color: L.paper, marginBottom: 4, letterSpacing: '-0.011em' }}>Iniciar sesión</div>
        <div style={{ fontSize: 13, color: L.fog, marginBottom: 28, letterSpacing: '-0.011em' }}>Ingresá tus credenciales para continuar</div>

        <form onSubmit={handleLogin}>
          <div style={{ marginBottom: 14 }}>
            <label style={labelStyle}>Email</label>
            <input type="email" value={email} onChange={e => setEmail(e.target.value)}
              placeholder="tu@email.com" required autoFocus style={inputStyle}
              onFocus={e => e.target.style.borderColor = L.blue}
              onBlur={e => e.target.style.borderColor = L.graphite}
            />
          </div>
          <div style={{ marginBottom: 8 }}>
            <label style={labelStyle}>Contraseña</label>
            <input type="password" value={password} onChange={e => setPassword(e.target.value)}
              placeholder="••••••••" required style={inputStyle}
              onFocus={e => e.target.style.borderColor = L.blue}
              onBlur={e => e.target.style.borderColor = L.graphite}
            />
          </div>

          <div style={{ textAlign: 'right', marginBottom: 20 }}>
            <button type="button" onClick={() => { setVista('recovery'); setEmailRecovery(email); }}
              style={{ background: 'none', border: 'none', fontSize: 12, color: L.fog, cursor: 'pointer', padding: 0, fontWeight: 400, fontFamily: inter, letterSpacing: '-0.011em', transition: 'color 0.15s' }}
              onMouseEnter={e => e.currentTarget.style.color = L.mist}
              onMouseLeave={e => e.currentTarget.style.color = L.fog}
            >
              ¿Olvidaste tu contraseña?
            </button>
          </div>

          <ErrorBox msg={error} />

          <button type="submit" disabled={loading} style={{ width: '100%', background: L.blue, color: L.paper, border: 'none', borderRadius: 6, padding: '11px', fontSize: 14, fontWeight: 510, cursor: loading ? 'not-allowed' : 'pointer', opacity: loading ? 0.7 : 1, letterSpacing: '-0.011em', fontFamily: inter, transition: 'background 0.15s' }}
            onMouseEnter={e => { if (!loading) e.currentTarget.style.background = L.blueDim; }}
            onMouseLeave={e => e.currentTarget.style.background = L.blue}
          >
            {loading ? 'Ingresando...' : 'Ingresar'}
          </button>
        </form>
      </div>
    </div>
  );
}
